module.exports = __webpack_public_path__ + "static/media/Minh_Do.fca24aaa.png";